export const AuthRoutesList = {
  LOGIN_PAGE: 'login',
  ACCOUNT_ACTIVATE_PAGE: 'account-activate',
  FORGOT_PASSWORD_PAGE: 'forgot-password',
  RESET_PASSWORD_PAGE: 'reset-password',
  LOGOUT_PAGE: 'logout',
};

export default AuthRoutesList;
